<script>
import { CONSTANT } from '../../../../utils/constant.js'
import sharedService from '@/utils/shared-service'
import ConfigurationService from '@/components/configuration/configuration.service'

const configurationService = new ConfigurationService()

export default {
  name: 'DcfVariance',

  data () {
    return {
      CONSTANT: CONSTANT,
      configurationService: configurationService
    }
  },
  computed: {
    mastercardDcfPreference: {
      get () {
        return this.$store.state.configuration.checkout.mastercardDcfPreference
      },
      set (value) {
        this.$store.commit('updateMastercardDcfPreference', value)
        sharedService.updateCheckoutButton(false)
      }
    },
    amexDcfPreference: {
      get () {
        return this.$store.state.configuration.checkout.amexDcfPreference
      },
      set (value) {
        this.$store.commit('updateAmexDcfPreference', value)
        sharedService.updateCheckoutButton(false)
      }
    },
    visaDcfPreference: {
      get () {
        return this.$store.state.configuration.checkout.visaDcfPreference
      },
      set (value) {
        this.$store.commit('updateVisaDcfPreference', value)
        sharedService.updateCheckoutButton(false)
      }
    },
    discoverDcfPreference: {
      get () {
        return this.$store.state.configuration.checkout.discoverDcfPreference
      },
      set (value) {
        this.$store.commit('updateDiscoverDcfPreference', value)
        sharedService.updateCheckoutButton(false)
      }
    }
  }
}
</script>
<template>
  <div
    id="dcfVarianceSelection"
    class="card mb-4">
    <h5
      aria-controls="dcfVariance"
      aria-expanded="true"
      class="card-header collapsed cursor-pointer"
      data-target="#dcfVariance"
      data-toggle="collapse"
    >
      <span class="font-weight-bold">{{ $t("label.dcfPreference") }}</span>
      <span class="collapsible-arrow pull-right cursor-pointer" />
    </h5>
    <div
      id="dcfVariance"
      class="card-body collapse">
      <div class="row">
        <div class="col-sm-3 col-md-3 col-lg-3 mt-2">
          <label>{{ $t("sdk.mastercard") }}</label>
          <div class="mt-1">
            <input
              id="mastercardDcfPreference"
              v-model="mastercardDcfPreference"
              list="mastercardList"
              class="form-control"
            >
            <datalist id="mastercardList">
              <option
                v-for="(key, value) in CONSTANT.CONFIG
                .MASTERCARD_DCF_PREFERENCE"
                :key="key"
                :value="value"
              >
                {{ value }}
              </option>
            </datalist>
          </div>
        </div>

        <div class="col-sm-3 col-md-3 col-lg-3 mt-2">
          <label>{{ $t("sdk.amex") }}</label>
          <div class="mt-1">
            <input
              id="amexDcfPreference"
              v-model="amexDcfPreference"
              list="amexList"
              class="form-control"
            >
            <datalist id="amexList">
              <option
                v-for="(key, value) in CONSTANT.CONFIG.AMEX_DCF_PREFERENCE"
                :key="key"
                :value="value"
              >
                {{ value }}
              </option>
            </datalist>
          </div>
        </div>

        <div class="col-sm-3 col-md-3 col-lg-3 mt-2">
          <label>{{ $t("sdk.visa") }}</label>
          <div class="mt-1">
            <input
              id="visaDcfPreference"
              v-model="visaDcfPreference"
              list="visaList"
              class="form-control"
            >
            <datalist id="visaList">
              <option
                v-for="(key, value) in CONSTANT.CONFIG.VISA_DCF_PREFERENCE"
                :key="key"
                :value="value"
              >
                {{ value }}
              </option>
            </datalist>
          </div>
        </div>

        <div class="col-sm-3 col-md-3 col-lg-3 mt-2">
          <label>{{ $t("sdk.discover") }}</label>
          <div class="mt-1">
            <input
              id="discoverDcfPreference"
              v-model="discoverDcfPreference"
              list="discoverList"
              class="form-control"
            >
            <datalist id="discoverList">
              <option
                v-for="(key, value) in CONSTANT.CONFIG.DISCOVER_DCF_PREFERENCE"
                :key="key"
                :value="value"
              >
                {{ value }}
              </option>
            </datalist>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
